"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VSelectFormControl = VSelectFormControl;
exports.VSelectSelect = VSelectSelect;
exports.default = VSelect;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("./VSelect.css");

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

var _excluded = ["label", "emptyLabel", "error", "children", "fullWidth", "disabled"],
    _excluded2 = ["label", "emptyLabel", "children", "disabled"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @visibleName VSelect
 */
function VSelect(_ref) {
  var label = _ref.label,
      emptyLabel = _ref.emptyLabel,
      error = _ref.error,
      children = _ref.children,
      fullWidth = _ref.fullWidth,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(VSelectFormControl, {
    label: label,
    error: error,
    fullWidth: fullWidth,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(VSelectSelect, _extends({
    label: label,
    emptyLabel: emptyLabel,
    disabled: disabled
  }, rest), children));
}

function VSelectFormControl(_ref2) {
  var label = _ref2.label,
      error = _ref2.error,
      children = _ref2.children,
      fullWidth = _ref2.fullWidth,
      disabled = _ref2.disabled;
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    variant: "outlined",
    className: "VaalTextField VaalSelect",
    error: error,
    fullWidth: fullWidth,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    disabled: disabled
  }, label), children);
}

function VSelectSelect(_ref3) {
  var label = _ref3.label,
      emptyLabel = _ref3.emptyLabel,
      children = _ref3.children,
      disabled = _ref3.disabled,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var isOpen = false;
  var svgClasses = 'MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined';
  return /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    label: label,
    onOpen: function onOpen() {
      isOpen = true;
    },
    onClose: function onClose() {
      isOpen = false;
    },
    IconComponent: function IconComponent() {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: "arrowDown",
        color: disabled ? _Colors.default.withOpacity(_Colors.default.vagaVesi, 0.38) : _Colors.default.vagaVesi,
        className: isOpen ? svgClasses.concat(' MuiSelect-iconOpen') : svgClasses
      });
    },
    MenuProps: {
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    },
    disabled: disabled
  }, rest), children, emptyLabel && /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    value: "",
    className: "select-default-none",
    style: {
      color: _Colors.default.hapumarjapuu
    }
  }, emptyLabel));
}

VSelect.propTypes = {
  /** Elements to be rendered as options of dropdown list*/
  children: _propTypes.default.node,

  /** Label */
  label: _propTypes.default.string,

  /** label of empty element, if not provided then empty element not rendered */
  emptyLabel: _propTypes.default.string,

  /** Other properties */
  rest: _propTypes.default.any
};
VSelect.defaultProps = {
  label: 'Välja nimi'
};